export default __webpack_public_path__ + "static/media/gridImg6.3cf05b7b.jpg";